import styled from "styled-components";

import { VOTEBOX_FONT_SIZE_SMALL } from "../common/voteboxTokens";

const isZoomTemplate = document
    .getElementById("DesignVote")
    ?.classList.contains("streaming");

export const Wrapper = styled.div`
    width: 100%;
`;

export const WrapperVote = styled.div`
    width: ${() => (isZoomTemplate ? "90%" : "100%")};
    @media (max-width: 768px) {
        max-width: 350px;
    }
`;

export const StyledProxyText = styled.p`
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
    margin: 0.5rem 0;
`;
